import { siteApiSlice } from "../../app/siteApiSlice";
import NamedEntity from "../../interfaces/NamedEntity";

export const _defaultCountry = "United States";

export interface GetSchoolsRequestModel {
	districtCode: string;
}

export interface ZoneModel {
	id: number;
	name: string;
	country: NamedEntity;
}

const ONE_YEAR = 60 * 60 * 24 * 365;

export const countriesApiSlice = siteApiSlice.injectEndpoints({
	endpoints: (build) => ({
		getCountries: build.query<NamedEntity[], void>({
			query: () => ({
				url: `/Country/GetCountries`,
			}),
			keepUnusedDataFor: ONE_YEAR,
		}),
		getZones: build.query<NamedEntity[], number>({
			query: (id) => ({
				url: `/Country/GetZones`,
				params: { id },
			}),
		}),
	}),
});

export const { useGetCountriesQuery, useLazyGetZonesQuery } = countriesApiSlice;
